import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { getVideos } from "@/data/mediathequeStore";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft, Youtube } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const MediathequePage = () => {
  const { lang, isRtl } = useI18n();
  const videos = getVideos().filter(v => v.published);

  return (
    <div className="min-h-screen flex flex-col bg-background" dir={isRtl ? "rtl" : "ltr"}>
      <Navbar />
      <main className="flex-1 container mx-auto py-24 px-4">
        <Button variant="ghost" className="mb-8 font-body -ml-4 hover:bg-transparent hover:text-primary transition-colors text-muted-foreground" asChild>
          <Link to="/emissions">
            <ArrowLeft className={`w-4 h-4 mr-2 rtl:ml-2 rtl:mr-0 rtl:rotate-180`} /> 
            {lang === 'ar' ? 'العودة للبرامج' : lang === 'zgh' ? 'ⵓⵖⴰⵍ ⵖⵔ ⵉⵖⴰⵡⴰⵙⵏ' : 'Retour aux émissions'}
          </Link>
        </Button>

        <div className="mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-extrabold text-foreground flex items-center gap-3">
            <Youtube className="w-8 h-8 sm:w-10 sm:h-10 text-red-600" /> 
            La médiathèque Kayn'in
          </h1>
          <p className="mt-4 text-base sm:text-lg font-body text-muted-foreground max-w-2xl">
            Retrouvez toutes les émissions et vidéos du mois en cours.
          </p>
        </div>

        {videos.length === 0 ? (
          <div className="text-center py-20 bg-muted/20 rounded-2xl border border-dashed border-border">
            <p className="text-muted-foreground font-body">Aucune vidéo disponible pour le moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {videos.map((video) => (
              <div key={video.id} className="bg-card rounded-2xl overflow-hidden border border-border shadow-sm flex flex-col group hover:shadow-md transition-shadow">
                {video.embedUrl ? (
                  <div className="relative w-full aspect-video bg-black">
                    <iframe 
                      src={video.embedUrl} 
                      title={video.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                      allowFullScreen
                      className="absolute top-0 left-0 w-full h-full border-0"
                    />
                  </div>
                ) : (
                  <div className="relative w-full aspect-video bg-muted flex items-center justify-center">
                     <span className="text-muted-foreground text-sm font-body">Lien vidéo invalide</span>
                  </div>
                )}
                <div className="p-4 md:p-6 flex flex-col flex-1">
                  <h3 className="font-display font-bold text-lg text-foreground line-clamp-2 mb-4 group-hover:text-red-600 transition-colors">
                    {video.title}
                  </h3>
                  <div className="mt-auto flex justify-between items-center">
                    <Button variant="outline" size="sm" asChild className="gap-2 font-body rounded-full hover:bg-red-50 hover:text-red-700 hover:border-red-200">
                      <a href={video.youtubeUrl} target="_blank" rel="noopener noreferrer">
                        <Youtube className="w-4 h-4 text-red-600" /> Voir sur YouTube
                      </a>
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default MediathequePage;
